import AnchorAPIError from '../../AnchorAPIError';

export type LastPayout = {
  amount: number;
  createdUnixTimestamp: number;
  currency: string;
};

export type StripePaymentSource = {
  allTimeTotalCents: number;
  currentBalanceCents: number;
  lastPayout: LastPayout | null;
  pendingBalanceCents: number | null;
};

export type SpotifyPaymentSource = {
  allTimeTotalCents: number;
  currentBalanceCents: number;
};

export type FetchCurrentPodcastWalletResponse = {
  hasEverActivatedCampaign: boolean;
  isStripeOnboardingCompleted: boolean;
  currentWalletAmountInCents: number; // deprecated, use sources.stripe.currentBalanceCents
  pendingWalletAmountInCents: number; // deprecated, user sources.stripe.pendingBalanceCents
  allTimeWalletAmountInCents: number;
  allTimeWalletBreakdown?: {
    amount: number;
    anchorFee: number;
    net: number; // deprecated, use sources.total.allTimeTotalCents
    paid: number;
    processorFee: number;
    payoutFee: number;
    totalAllTimeEarned: number;
  };
  normalPayoutProcessingFeeInCents: number;
  instantPayoutProcessingFeeInCents: number;
  isPayoutEnabled: boolean;
  isInstantPayoutAvailable: boolean;
  areStripeRequirementsMet: boolean;
  doShowActivateAllButton: boolean;
  lastPayout: LastPayout | null; // deprecated, use sources.stripe.lastPayout
  stripeDashboardURL: string | null;
  w8CollectionRequired: boolean;
  currency: string | null;
  minimumCashoutAmount: number; // In cents
  sources: {
    stripe: StripePaymentSource | null;
    spotifyPayments: SpotifyPaymentSource | null;
    total: { allTimeTotalCents: number; currentBalanceCents: number };
  };
};

const fetchCurrentPodcastWallet = ({ shouldBustCache = false } = {}) =>
  new Promise<FetchCurrentPodcastWalletResponse>((resolve, reject) => {
    const baseUrlPath = '/api/proxy/v3/wallet';
    const urlPath = shouldBustCache
      ? `${baseUrlPath}?${Date.now()}`
      : baseUrlPath;
    fetch(urlPath, {
      credentials: 'same-origin',
      method: 'GET',
    }).then((response: any): void => {
      if (response.ok) {
        response.json().then((responseJson: any) => {
          resolve(responseJson);
        });
      } else {
        const error = new AnchorAPIError(response, 'Server error.');
        reject(error);
      }
    });
  });

export { fetchCurrentPodcastWallet };
